module.exports = __webpack_public_path__ + "img/logoDark.a4327d65.svg";